"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uploadFileResponseSchema = exports.attachmentResponseSchema = void 0;
const zod_1 = require("zod");
const constants_1 = require("../constants");
const shortField_schema_1 = require("./shortField.schema");
exports.attachmentResponseSchema = zod_1.z
    .object({
    fileName: shortField_schema_1.shortFieldSchema,
    sizeInBytes: zod_1.z.number().positive().min(1).max(constants_1.MAX_FILE_SIZE),
    uploadUrl: zod_1.z.string().optional(),
})
    .strict();
exports.uploadFileResponseSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    files: exports.attachmentResponseSchema.array().nonempty(),
})
    .strict();
//# sourceMappingURL=uploadFileResponse.schema.js.map